import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@iotsens/commands/src/lib/_shared';
import { CommandComponent, SharedModule } from '@iotsens/commands/src/lib/_shared';
import { __decorate } from 'tslib';
import * as i2 from 'primeng/selectbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import * as i3 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i2$1 from 'primeng/inputnumber';
import { InputNumberModule } from 'primeng/inputnumber';
import * as i2$2 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';

const CommandLookupRegistry = new Map();

class Zmxconnect0262V1CommandBuilderComponent {
    constructor() {
        this.commandRegistry = CommandLookupRegistry;
        this.onExecute = new EventEmitter();
    }
    ngOnInit() { }
}
Zmxconnect0262V1CommandBuilderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1CommandBuilderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
Zmxconnect0262V1CommandBuilderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: Zmxconnect0262V1CommandBuilderComponent, selector: "iot-zmxconnect-0262-v1-command-builder", inputs: { commands: "commands", configuration: "configuration" }, outputs: { onExecute: "onExecute" }, ngImport: i0, template: "<iot-command-form [commandRegistry]=\"commandRegistry\" [commands]=\"commands\" [configuration]=\"this.configuration\" (onExecute)=\"this.onExecute.emit($event)\"></iot-command-form>", styles: [""], components: [{ type: i1.CommandFormComponent, selector: "iot-command-form", inputs: ["commands", "commandRegistry", "configuration"], outputs: ["onExecute"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1CommandBuilderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-command-builder',
                    templateUrl: './command-builder.component.html',
                    styleUrls: ['./command-builder.component.css']
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { commands: [{
                type: Input
            }], onExecute: [{
                type: Output
            }], configuration: [{
                type: Input
            }] } });

const CommandLookup = (key) => {
    return (component) => {
        CommandLookupRegistry.set(key, component);
    };
};

let GetMemmapComponent = class GetMemmapComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Get mem map'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
GetMemmapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GetMemmapComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
GetMemmapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: GetMemmapComponent, selector: "iot-zmxconnect-0262-v1-get-memmap", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
GetMemmapComponent = __decorate([
    CommandLookup('getMemmap')
], GetMemmapComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GetMemmapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-get-memmap',
                    templateUrl: './get-memmap.component.html',
                    styleUrls: ['./get-memmap.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MemmapComponent = class MemmapComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Mem map'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MemmapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MemmapComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MemmapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MemmapComponent, selector: "iot-zmxconnect-0262-v1-memmap", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MemmapComponent = __decorate([
    CommandLookup('memmap')
], MemmapComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MemmapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-memmap',
                    templateUrl: './memmap.component.html',
                    styleUrls: ['./memmap.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let RebootComponent = class RebootComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Reboot'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
RebootComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RebootComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebootComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: RebootComponent, selector: "iot-zmxconnect-0262-v1-reboot", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
RebootComponent = __decorate([
    CommandLookup('reboot')
], RebootComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RebootComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-reboot',
                    templateUrl: './reboot.component.html',
                    styleUrls: ['./reboot.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let RestoreFifoComponent = class RestoreFifoComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Restore fifo'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
RestoreFifoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RestoreFifoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RestoreFifoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: RestoreFifoComponent, selector: "iot-zmxconnect-0262-v1-restore-fifo", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
RestoreFifoComponent = __decorate([
    CommandLookup('restoreFifo')
], RestoreFifoComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RestoreFifoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-restore-fifo',
                    templateUrl: './restore-fifo.component.html',
                    styleUrls: ['./restore-fifo.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let SetSweeperEnabledComponent = class SetSweeperEnabledComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set sweeper enabled',
            params: {
                enabled: {
                    name: '',
                    labels: {
                        '0': 'Disabled',
                        '1': 'Enabled'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.enabledConfiguration = this.getParamConfiguration('enabled');
        this.enabledOptions = this.getParamOptions('enabled');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'enabled') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetSweeperEnabledComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperEnabledComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetSweeperEnabledComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetSweeperEnabledComponent, selector: "iot-zmxconnect-0262-v1-set-sweeper-enabled", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"enabled\"> {{ this.enabledConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.enabledOptions\" id=\"enabled\" formControlName=\"enabled\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetSweeperEnabledComponent = __decorate([
    CommandLookup('setSweeperEnabled')
], SetSweeperEnabledComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperEnabledComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-sweeper-enabled',
                    templateUrl: './set-sweeper-enabled.component.html',
                    styleUrls: ['./set-sweeper-enabled.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetPinCtComponent = class SetPinCtComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set pin CT',
            params: {
                pin: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.pinConfiguration = this.getParamConfiguration('pin');
        this.pinOptions = this.getParamOptions('pin');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'pin') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetPinCtComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinCtComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetPinCtComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetPinCtComponent, selector: "iot-zmxconnect-0262-v1-set-pin-ct", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"pin\"> {{ this.pinConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"pin\" formControlName=\"pin\" [min]=\"pinOptions.min\" [max]=\"pinOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetPinCtComponent = __decorate([
    CommandLookup('setPinCt')
], SetPinCtComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinCtComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-pin-ct',
                    templateUrl: './set-pin-ct.component.html',
                    styleUrls: ['./set-pin-ct.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetSweeperModeComponent = class SetSweeperModeComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set sweeper mode',
            params: {
                mode: {
                    name: '',
                    labels: {
                        '0': 'OFF',
                        '1': 'ON'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.modeConfiguration = this.getParamConfiguration('mode');
        this.modeOptions = this.getParamOptions('mode');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'mode') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetSweeperModeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperModeComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetSweeperModeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetSweeperModeComponent, selector: "iot-zmxconnect-0262-v1-set-sweeper-mode", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"mode\"> {{ this.modeConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.modeOptions\" id=\"mode\" formControlName=\"mode\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetSweeperModeComponent = __decorate([
    CommandLookup('setSweeperMode')
], SetSweeperModeComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperModeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-sweeper-mode',
                    templateUrl: './set-sweeper-mode.component.html',
                    styleUrls: ['./set-sweeper-mode.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetSweeperSpeedComponent = class SetSweeperSpeedComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set sweeper speed',
            params: {
                speed: {
                    name: '',
                    labels: {
                        '0': 'Stop',
                        '1': 'Slow',
                        '2': 'Normal',
                        '3': 'Fast'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.speedConfiguration = this.getParamConfiguration('speed');
        this.speedOptions = this.getParamOptions('speed');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'speed') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetSweeperSpeedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperSpeedComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetSweeperSpeedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetSweeperSpeedComponent, selector: "iot-zmxconnect-0262-v1-set-sweeper-speed", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"speed\"> {{ this.speedConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.speedOptions\" id=\"speed\" formControlName=\"speed\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetSweeperSpeedComponent = __decorate([
    CommandLookup('setSweeperSpeed')
], SetSweeperSpeedComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSweeperSpeedComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-sweeper-speed',
                    templateUrl: './set-sweeper-speed.component.html',
                    styleUrls: ['./set-sweeper-speed.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetWasteEnabledComponent = class SetWasteEnabledComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set waste enabled',
            params: {
                enabled: {
                    name: '',
                    labels: {
                        '0': 'Disabled',
                        '1': 'Enabled'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.enabledConfiguration = this.getParamConfiguration('enabled');
        this.enabledOptions = this.getParamOptions('enabled');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'enabled') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetWasteEnabledComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetWasteEnabledComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetWasteEnabledComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetWasteEnabledComponent, selector: "iot-zmxconnect-0262-v1-set-waste-enabled", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"enabled\"> {{ this.enabledConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.enabledOptions\" id=\"enabled\" formControlName=\"enabled\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetWasteEnabledComponent = __decorate([
    CommandLookup('setWasteEnabled')
], SetWasteEnabledComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetWasteEnabledComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-waste-enabled',
                    templateUrl: './set-waste-enabled.component.html',
                    styleUrls: ['./set-waste-enabled.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetWasteLimitComponent = class SetWasteLimitComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set waste limit',
            params: {
                limit: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.limitConfiguration = this.getParamConfiguration('limit');
        this.limitOptions = this.getParamOptions('limit');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'limit') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetWasteLimitComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetWasteLimitComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetWasteLimitComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetWasteLimitComponent, selector: "iot-zmxconnect-0262-v1-set-waste-limit", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"limit\"> {{ this.limitConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"limit\" formControlName=\"limit\" [min]=\"limitOptions.min\" [max]=\"limitOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetWasteLimitComponent = __decorate([
    CommandLookup('setWasteLimit')
], SetWasteLimitComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetWasteLimitComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-waste-limit',
                    templateUrl: './set-waste-limit.component.html',
                    styleUrls: ['./set-waste-limit.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetPinMasterComponent = class SetPinMasterComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set pin master',
            params: {
                pin: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.pinConfiguration = this.getParamConfiguration('pin');
        this.pinOptions = this.getParamOptions('pin');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'pin') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetPinMasterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinMasterComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetPinMasterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetPinMasterComponent, selector: "iot-zmxconnect-0262-v1-set-pin-master", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"pin\"> {{ this.pinConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"pin\" formControlName=\"pin\" [min]=\"pinOptions.min\" [max]=\"pinOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetPinMasterComponent = __decorate([
    CommandLookup('setPinMaster')
], SetPinMasterComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinMasterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-pin-master',
                    templateUrl: './set-pin-master.component.html',
                    styleUrls: ['./set-pin-master.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetPinUserComponent = class SetPinUserComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set pin user',
            params: {
                pin: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.pinConfiguration = this.getParamConfiguration('pin');
        this.pinOptions = this.getParamOptions('pin');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'pin') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetPinUserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinUserComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetPinUserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetPinUserComponent, selector: "iot-zmxconnect-0262-v1-set-pin-user", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"pin\"> {{ this.pinConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"pin\" formControlName=\"pin\" [min]=\"pinOptions.min\" [max]=\"pinOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetPinUserComponent = __decorate([
    CommandLookup('setPinUser')
], SetPinUserComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinUserComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-pin-user',
                    templateUrl: './set-pin-user.component.html',
                    styleUrls: ['./set-pin-user.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetPinSatComponent = class SetPinSatComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set pin sat',
            params: {
                pin: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.pinConfiguration = this.getParamConfiguration('pin');
        this.pinOptions = this.getParamOptions('pin');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'pin') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetPinSatComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinSatComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetPinSatComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetPinSatComponent, selector: "iot-zmxconnect-0262-v1-set-pin-sat", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"pin\"> {{ this.pinConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"pin\" formControlName=\"pin\" [min]=\"pinOptions.min\" [max]=\"pinOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetPinSatComponent = __decorate([
    CommandLookup('setPinSat')
], SetPinSatComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetPinSatComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-pin-sat',
                    templateUrl: './set-pin-sat.component.html',
                    styleUrls: ['./set-pin-sat.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetIotTimeoutComponent = class SetIotTimeoutComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set IoT timeout',
            params: {
                minutes: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.minutesConfiguration = this.getParamConfiguration('minutes');
        this.minutesOptions = this.getParamOptions('minutes');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'minutes') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetIotTimeoutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetIotTimeoutComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetIotTimeoutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetIotTimeoutComponent, selector: "iot-zmxconnect-0262-v1-set-iot-timeout", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"minutes\"> {{ this.minutesConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"minutes\" formControlName=\"minutes\" [min]=\"minutesOptions.min\" [max]=\"minutesOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetIotTimeoutComponent = __decorate([
    CommandLookup('setIotTimeout')
], SetIotTimeoutComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetIotTimeoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-iot-timeout',
                    templateUrl: './set-iot-timeout.component.html',
                    styleUrls: ['./set-iot-timeout.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetIotSelControlComponent = class SetIotSelControlComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set IoT sel control',
            params: {
                mode: {
                    name: '',
                    labels: {
                        '0': 'OFF',
                        '1': 'PPU ON',
                        '2': 'IoT ON'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.modeConfiguration = this.getParamConfiguration('mode');
        this.modeOptions = this.getParamOptions('mode');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'mode') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetIotSelControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetIotSelControlComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetIotSelControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetIotSelControlComponent, selector: "iot-zmxconnect-0262-v1-set-iot-sel-control", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"mode\"> {{ this.modeConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.modeOptions\" id=\"mode\" formControlName=\"mode\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetIotSelControlComponent = __decorate([
    CommandLookup('setIotSelControl')
], SetIotSelControlComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetIotSelControlComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-iot-sel-control',
                    templateUrl: './set-iot-sel-control.component.html',
                    styleUrls: ['./set-iot-sel-control.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let MachineResetPartialFruitCounterComponent = class MachineResetPartialFruitCounterComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Reset partial fruit counter'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineResetPartialFruitCounterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineResetPartialFruitCounterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineResetPartialFruitCounterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineResetPartialFruitCounterComponent, selector: "iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineResetPartialFruitCounterComponent = __decorate([
    CommandLookup('machineResetPartialFruitCounter')
], MachineResetPartialFruitCounterComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineResetPartialFruitCounterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter',
                    templateUrl: './machine-reset-partial-fruit-counter.component.html',
                    styleUrls: ['./machine-reset-partial-fruit-counter.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MachineCpuResetComponent = class MachineCpuResetComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Reset CPU'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineCpuResetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineCpuResetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineCpuResetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineCpuResetComponent, selector: "iot-zmxconnect-0262-v1-machine-cpu-reset", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineCpuResetComponent = __decorate([
    CommandLookup('machineCpuReset')
], MachineCpuResetComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineCpuResetComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-cpu-reset',
                    templateUrl: './machine-cpu-reset.component.html',
                    styleUrls: ['./machine-cpu-reset.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MachineFactoryResetComponent = class MachineFactoryResetComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Reset factory'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineFactoryResetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineFactoryResetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineFactoryResetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineFactoryResetComponent, selector: "iot-zmxconnect-0262-v1-machine-factory-reset", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineFactoryResetComponent = __decorate([
    CommandLookup('machineFactoryReset')
], MachineFactoryResetComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineFactoryResetComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-factory-reset',
                    templateUrl: './machine-factory-reset.component.html',
                    styleUrls: ['./machine-factory-reset.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MachineFruitsCashlessResetComponent = class MachineFruitsCashlessResetComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Reset fruits cashless'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineFruitsCashlessResetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineFruitsCashlessResetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineFruitsCashlessResetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineFruitsCashlessResetComponent, selector: "iot-zmxconnect-0262-v1-machine-fruits-cashless-reset", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineFruitsCashlessResetComponent = __decorate([
    CommandLookup('machineFruitsCashlessReset')
], MachineFruitsCashlessResetComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineFruitsCashlessResetComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-fruits-cashless-reset',
                    templateUrl: './machine-fruits-cashless-reset.component.html',
                    styleUrls: ['./machine-fruits-cashless-reset.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MachineEnableComponent = class MachineEnableComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Enable machine'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineEnableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineEnableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineEnableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineEnableComponent, selector: "iot-zmxconnect-0262-v1-machine-enable", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineEnableComponent = __decorate([
    CommandLookup('machineEnable')
], MachineEnableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineEnableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-enable',
                    templateUrl: './machine-enable.component.html',
                    styleUrls: ['./machine-enable.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let MachineDisableComponent = class MachineDisableComponent extends CommandComponent {
    constructor() {
        super();
        this.defaultLiterals = {
            button: 'Disable machine'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: 'HEADER',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: true
        };
    }
    execute() {
        return {
            commandName: this.command,
            parameters: {}
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
MachineDisableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineDisableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MachineDisableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: MachineDisableComponent, selector: "iot-zmxconnect-0262-v1-machine-disable", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper \r\n    [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n</iot-command-wrapper>", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }] });
MachineDisableComponent = __decorate([
    CommandLookup('machineDisable')
], MachineDisableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MachineDisableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-machine-disable',
                    templateUrl: './machine-disable.component.html',
                    styleUrls: ['./machine-disable.component.css']
                }]
        }], ctorParameters: function () { return []; } });

let SetCashlessModeFruitNumberComponent = class SetCashlessModeFruitNumberComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set cashless mode fruit number',
            params: {
                amount: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.amountConfiguration = this.getParamConfiguration('amount');
        this.amountOptions = this.getParamOptions('amount');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'amount') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetCashlessModeFruitNumberComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetCashlessModeFruitNumberComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetCashlessModeFruitNumberComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetCashlessModeFruitNumberComponent, selector: "iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"amount\"> {{ this.amountConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"amount\" formControlName=\"amount\" [min]=\"amountOptions.min\" [max]=\"amountOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetCashlessModeFruitNumberComponent = __decorate([
    CommandLookup('setCashlessModeFruitNumber')
], SetCashlessModeFruitNumberComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetCashlessModeFruitNumberComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number',
                    templateUrl: './set-cashless-mode-fruit-number.component.html',
                    styleUrls: ['./set-cashless-mode-fruit-number.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetDownValueDiscComponent = class SetDownValueDiscComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set down value disc',
            params: {
                amount: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.amountConfiguration = this.getParamConfiguration('amount');
        this.amountOptions = this.getParamOptions('amount');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'amount') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetDownValueDiscComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetDownValueDiscComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetDownValueDiscComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetDownValueDiscComponent, selector: "iot-zmxconnect-0262-v1-set-down-value-disc", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"amount\"> {{ this.amountConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"amount\" formControlName=\"amount\" [min]=\"amountOptions.min\" [max]=\"amountOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetDownValueDiscComponent = __decorate([
    CommandLookup('setDownValueDisc')
], SetDownValueDiscComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetDownValueDiscComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-down-value-disc',
                    templateUrl: './set-down-value-disc.component.html',
                    styleUrls: ['./set-down-value-disc.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetLanguageComponent = class SetLanguageComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set language',
            params: {
                code: {
                    name: '',
                    labels: {
                        '0': 'Czech',
                        '1': 'Danish',
                        '2': 'German',
                        '3': 'English',
                        '4': 'Spanish',
                        '5': 'French',
                        '6': 'Italian',
                        '7': 'Hungarian',
                        '8': 'Dutch',
                        '9': 'Norwegian',
                        '10': 'Polish',
                        '11': 'Portuguese',
                        '12': 'Romanian',
                        '13': 'Swedish',
                        '14': 'Turkish',
                        '15': 'Bulgarian',
                        '16': 'Greek',
                        '17': 'Russian',
                        '18': 'Ukrainian',
                        '19': 'Chinese',
                        '20': 'Korean',
                        '21': 'Japanese',
                        '22': 'Arabic',
                        '23': 'Hebrew'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.codeConfiguration = this.getParamConfiguration('code');
        this.codeOptions = this.getParamOptions('code');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'code') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetLanguageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetLanguageComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetLanguageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetLanguageComponent, selector: "iot-zmxconnect-0262-v1-set-language", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"code\"> {{ this.codeConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-dropdown styleClass=\"w-full\" appendTo=\"body\" id=\"code\" formControlName=\"code\" optionLabel=\"label\"\r\n                                optionValue=\"value\" [options]=\"this.codeOptions\">\r\n                    </p-dropdown>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$2.Dropdown, selector: "p-dropdown", inputs: ["scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "filterPlaceholder", "filterLocale", "inputId", "selectId", "dataKey", "filterBy", "autofocus", "resetFilterOnHide", "dropdownIcon", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "virtualScroll", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaFilterLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "autofocusFilter", "disabled", "options", "filterValue"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetLanguageComponent = __decorate([
    CommandLookup('setLanguage')
], SetLanguageComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetLanguageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-language',
                    templateUrl: './set-language.component.html',
                    styleUrls: ['./set-language.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetFruitsProComponent = class SetFruitsProComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set fruits Pro',
            params: {
                amount: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.amountConfiguration = this.getParamConfiguration('amount');
        this.amountOptions = this.getParamOptions('amount');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'amount') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetFruitsProComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetFruitsProComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetFruitsProComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetFruitsProComponent, selector: "iot-zmxconnect-0262-v1-set-fruits-pro", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"amount\"> {{ this.amountConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"amount\" formControlName=\"amount\" [min]=\"amountOptions.min\" [max]=\"amountOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetFruitsProComponent = __decorate([
    CommandLookup('setFruitsPro')
], SetFruitsProComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetFruitsProComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-fruits-pro',
                    templateUrl: './set-fruits-pro.component.html',
                    styleUrls: ['./set-fruits-pro.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetLockProComponent = class SetLockProComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set lock Pro',
            params: {
                enabled: {
                    name: '',
                    labels: {
                        '0': 'Disabled',
                        '1': 'Enabled'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.enabledConfiguration = this.getParamConfiguration('enabled');
        this.enabledOptions = this.getParamOptions('enabled');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'enabled') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetLockProComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetLockProComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetLockProComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetLockProComponent, selector: "iot-zmxconnect-0262-v1-set-lock-pro", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"enabled\"> {{ this.enabledConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.enabledOptions\" id=\"enabled\" formControlName=\"enabled\" optionLabel=\"label\"\r\n                                  optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetLockProComponent = __decorate([
    CommandLookup('setLockPro')
], SetLockProComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetLockProComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-lock-pro',
                    templateUrl: './set-lock-pro.component.html',
                    styleUrls: ['./set-lock-pro.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetSelUpDownDiscComponent = class SetSelUpDownDiscComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set sel up down disc',
            params: {
                state: {
                    name: '',
                    labels: {
                        '0': 'OFF',
                        '1': 'UP',
                        '2': 'DOWN'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.stateConfiguration = this.getParamConfiguration('state');
        this.stateOptions = this.getParamOptions('state');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'state') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetSelUpDownDiscComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSelUpDownDiscComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetSelUpDownDiscComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetSelUpDownDiscComponent, selector: "iot-zmxconnect-0262-v1-set-sel-up-down-disc", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"state\"> {{ this.stateConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.stateOptions\" id=\"state\" formControlName=\"state\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetSelUpDownDiscComponent = __decorate([
    CommandLookup('setSelUpDownDisc')
], SetSelUpDownDiscComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetSelUpDownDiscComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-sel-up-down-disc',
                    templateUrl: './set-sel-up-down-disc.component.html',
                    styleUrls: ['./set-sel-up-down-disc.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetUpValueComponent = class SetUpValueComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set up value',
            params: {
                amount: {
                    name: ''
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.amountConfiguration = this.getParamConfiguration('amount');
        this.amountOptions = this.getParamOptions('amount');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'amount') {
            const validRange = validator.validRange;
            return { min: validRange[0], max: validRange[1] };
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetUpValueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetUpValueComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetUpValueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetUpValueComponent, selector: "iot-zmxconnect-0262-v1-set-up-value", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"amount\"> {{ this.amountConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input p-inputgroup\">\r\n                    <p-inputNumber id=\"amount\" formControlName=\"amount\" [min]=\"amountOptions.min\" [max]=\"amountOptions.max\">\r\n                    </p-inputNumber>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2$1.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetUpValueComponent = __decorate([
    CommandLookup('setUpValue')
], SetUpValueComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetUpValueComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-up-value',
                    templateUrl: './set-up-value.component.html',
                    styleUrls: ['./set-up-value.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

let SetCommTechComponent = class SetCommTechComponent extends CommandComponent {
    constructor(buildFormService) {
        super();
        this.buildFormService = buildFormService;
        this.defaultLiterals = {
            command: 'Set comm tech',
            params: {
                mode: {
                    name: '',
                    labels: {
                        '0': 'GPRS',
                        '1': 'WIFI'
                    }
                }
            },
            button: 'Save'
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.configuration.literals = Object.assign(Object.assign({}, this.defaultLiterals), this.configuration.literals);
        this._params = this.getCommandParams(this.params);
        this.modeConfiguration = this.getParamConfiguration('mode');
        this.modeOptions = this.getParamOptions('mode');
        this.formGroup = this.buildFormService.buildForm(this._params);
        if (this.configuration.value != null)
            this.formGroup.patchValue(this.configuration.value);
    }
    get buttonConfiguration() {
        return {
            buttonPosition: this.configuration.inline ? 'INLINE' : 'NEW_LINE',
            classes: this.configuration.buttonClasses,
            literal: this.configuration.literals.button,
            valid: this.formGroup.valid
        };
    }
    getParamConfiguration(param) {
        var _a;
        if (this.configuration.literals.params && this.configuration.literals.params[param] != null)
            return (_a = this.configuration.literals) === null || _a === void 0 ? void 0 : _a.params[param];
        else
            return { name: 'N/D' };
    }
    getCommandParams(params) {
        return Object.entries(params.params);
    }
    getParamOptions(param) {
        const validator = this.params.params[param].validators[0];
        if (param === 'mode') {
            const values = validator.validValues;
            if (this.configuration.literals.params) {
                const labels = this.configuration.literals.params[param].labels;
                return values.map(v => { return { label: labels[v], value: v }; });
            }
            else {
                return values.map(v => { return { label: v, value: v }; });
            }
        }
        return null;
    }
    execute() {
        return {
            commandName: this.command,
            parameters: this.formGroup.value
        };
    }
    onExecuteButtonClick() {
        const commandExec = this.execute();
        this.onExecute.emit(commandExec);
    }
};
SetCommTechComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetCommTechComponent, deps: [{ token: i1.BuildFormService }], target: i0.ɵɵFactoryTarget.Component });
SetCommTechComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SetCommTechComponent, selector: "iot-zmxconnect-0262-v1-set-comm-tech", usesInheritance: true, ngImport: i0, template: "<iot-command-wrapper header=\"{{ this.configuration.literals.command }}\" [configuration]=\"buttonConfiguration\"\r\n    (onExecute)=\"this.onExecuteButtonClick()\">\r\n    <form [formGroup]=\"formGroup\">\r\n        <div class=\"grid\">\r\n            <div class=\"command\" [ngClass]=\"this.commandClasses\">\r\n                <div class=\"label text-color-secondary line-height-3\">\r\n                    <label for=\"mode\"> {{ this.modeConfiguration.name }}\r\n                    </label>\r\n                </div>\r\n                <div class=\"input\">\r\n                    <p-selectButton [options]=\"this.modeOptions\" id=\"mode\" formControlName=\"mode\" optionLabel=\"label\"\r\n                        optionValue=\"value\"></p-selectButton>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</iot-command-wrapper>\r\n", styles: [""], components: [{ type: i1.CommandWrapperComponent, selector: "iot-command-wrapper", inputs: ["header", "configuration"], outputs: ["onExecute"] }, { type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }] });
SetCommTechComponent = __decorate([
    CommandLookup('setCommTech')
], SetCommTechComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SetCommTechComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'iot-zmxconnect-0262-v1-set-comm-tech',
                    templateUrl: './set-comm-tech.component.html',
                    styleUrls: ['./set-comm-tech.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1.BuildFormService }]; } });

class Zmxconnect0262V1Module {
}
Zmxconnect0262V1Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
Zmxconnect0262V1Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1Module, declarations: [Zmxconnect0262V1CommandBuilderComponent,
        RebootComponent,
        MemmapComponent,
        RestoreFifoComponent,
        GetMemmapComponent,
        SetSweeperEnabledComponent,
        SetSweeperModeComponent,
        SetSweeperSpeedComponent,
        SetWasteEnabledComponent,
        SetWasteLimitComponent,
        SetLanguageComponent,
        SetFruitsProComponent,
        SetLockProComponent,
        SetSelUpDownDiscComponent,
        SetDownValueDiscComponent,
        SetUpValueComponent,
        SetCashlessModeFruitNumberComponent,
        SetPinCtComponent,
        SetPinMasterComponent,
        SetPinUserComponent,
        SetPinSatComponent,
        SetIotTimeoutComponent,
        SetIotSelControlComponent,
        SetCommTechComponent,
        MachineResetPartialFruitCounterComponent,
        MachineCpuResetComponent,
        MachineFactoryResetComponent,
        MachineFruitsCashlessResetComponent,
        MachineEnableComponent,
        MachineDisableComponent], imports: [CommonModule,
        SharedModule,
        SelectButtonModule,
        InputNumberModule,
        DropdownModule,
        ReactiveFormsModule], exports: [Zmxconnect0262V1CommandBuilderComponent,
        RebootComponent,
        MemmapComponent,
        RestoreFifoComponent,
        GetMemmapComponent,
        SetSweeperEnabledComponent,
        SetSweeperModeComponent,
        SetSweeperSpeedComponent,
        SetWasteEnabledComponent,
        SetWasteLimitComponent,
        SetLanguageComponent,
        SetFruitsProComponent,
        SetLockProComponent,
        SetSelUpDownDiscComponent,
        SetDownValueDiscComponent,
        SetUpValueComponent,
        SetCashlessModeFruitNumberComponent,
        SetPinCtComponent,
        SetPinMasterComponent,
        SetPinUserComponent,
        SetPinSatComponent,
        SetIotTimeoutComponent,
        SetIotSelControlComponent,
        SetCommTechComponent,
        MachineResetPartialFruitCounterComponent,
        MachineCpuResetComponent,
        MachineFactoryResetComponent,
        MachineFruitsCashlessResetComponent,
        MachineEnableComponent,
        MachineDisableComponent] });
Zmxconnect0262V1Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1Module, imports: [[
            CommonModule,
            SharedModule,
            SelectButtonModule,
            InputNumberModule,
            DropdownModule,
            ReactiveFormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Zmxconnect0262V1Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        Zmxconnect0262V1CommandBuilderComponent,
                        RebootComponent,
                        MemmapComponent,
                        RestoreFifoComponent,
                        GetMemmapComponent,
                        SetSweeperEnabledComponent,
                        SetSweeperModeComponent,
                        SetSweeperSpeedComponent,
                        SetWasteEnabledComponent,
                        SetWasteLimitComponent,
                        SetLanguageComponent,
                        SetFruitsProComponent,
                        SetLockProComponent,
                        SetSelUpDownDiscComponent,
                        SetDownValueDiscComponent,
                        SetUpValueComponent,
                        SetCashlessModeFruitNumberComponent,
                        SetPinCtComponent,
                        SetPinMasterComponent,
                        SetPinUserComponent,
                        SetPinSatComponent,
                        SetIotTimeoutComponent,
                        SetIotSelControlComponent,
                        SetCommTechComponent,
                        MachineResetPartialFruitCounterComponent,
                        MachineCpuResetComponent,
                        MachineFactoryResetComponent,
                        MachineFruitsCashlessResetComponent,
                        MachineEnableComponent,
                        MachineDisableComponent
                    ],
                    imports: [
                        CommonModule,
                        SharedModule,
                        SelectButtonModule,
                        InputNumberModule,
                        DropdownModule,
                        ReactiveFormsModule
                    ],
                    exports: [
                        Zmxconnect0262V1CommandBuilderComponent,
                        RebootComponent,
                        MemmapComponent,
                        RestoreFifoComponent,
                        GetMemmapComponent,
                        SetSweeperEnabledComponent,
                        SetSweeperModeComponent,
                        SetSweeperSpeedComponent,
                        SetWasteEnabledComponent,
                        SetWasteLimitComponent,
                        SetLanguageComponent,
                        SetFruitsProComponent,
                        SetLockProComponent,
                        SetSelUpDownDiscComponent,
                        SetDownValueDiscComponent,
                        SetUpValueComponent,
                        SetCashlessModeFruitNumberComponent,
                        SetPinCtComponent,
                        SetPinMasterComponent,
                        SetPinUserComponent,
                        SetPinSatComponent,
                        SetIotTimeoutComponent,
                        SetIotSelControlComponent,
                        SetCommTechComponent,
                        MachineResetPartialFruitCounterComponent,
                        MachineCpuResetComponent,
                        MachineFactoryResetComponent,
                        MachineFruitsCashlessResetComponent,
                        MachineEnableComponent,
                        MachineDisableComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { GetMemmapComponent, MachineCpuResetComponent, MachineDisableComponent, MachineEnableComponent, MachineFactoryResetComponent, MachineFruitsCashlessResetComponent, MachineResetPartialFruitCounterComponent, MemmapComponent, RebootComponent, RestoreFifoComponent, SetCashlessModeFruitNumberComponent, SetCommTechComponent, SetDownValueDiscComponent, SetFruitsProComponent, SetIotSelControlComponent, SetIotTimeoutComponent, SetLanguageComponent, SetLockProComponent, SetPinCtComponent, SetPinMasterComponent, SetPinSatComponent, SetPinUserComponent, SetSelUpDownDiscComponent, SetSweeperEnabledComponent, SetSweeperModeComponent, SetSweeperSpeedComponent, SetUpValueComponent, SetWasteEnabledComponent, SetWasteLimitComponent, Zmxconnect0262V1CommandBuilderComponent, Zmxconnect0262V1Module };
